import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { FLEET_VEHICLE_FIRE_EXTINGUISHER_SEARCH_COLUMNS } from "./consts";
import { VehicleFireExtinguisherSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const VehicleSearchResults: React.FC<
  VehicleFireExtinguisherSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_FIRE_EXTINGUISHER_SEARCH_COLUMNS(t, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(VehicleSearchResults);
